import { Box } from '@chakra-ui/react';

export const ICON_SIZES = { NORMAL: 'normal', SMALL: 'small' };

export const GradientBGCard = ({ children, ...props }) => (
  <Box
    borderRadius="8px"
    border="1px solid"
    borderColor="border.EBEFF3"
    bg="linear-gradient(180deg, #F5F7F9 0%, rgba(245, 247, 249, 0) 100%)"
    p={3}
    pb={4}
    {...props}
  >
    {children}
  </Box>
);
